<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";
  import SalesforceChat from "@shared/services/salesforce_chat";
  import {
    ProductLineListingStore,
    updateProductLineListingStore,
  } from "@retailer/svelte/ProductLines/ProductLineContainer/stores/ProductLineListingStore";
  import { onDestroy } from "svelte";

  let filtersCount: number;

  const unsubscribe = ProductLineListingStore.subscribe(n => {
    filtersCount = n.filtersCount;
    if (n.mobileFiltersVisible) {
      SalesforceChat.hide();
    } else {
      SalesforceChat.unhide();
    }
  });

  onDestroy(() => {
    unsubscribe();
  });

  function swapFilters() {
    updateProductLineListingStore(n => {
      n.mobileFiltersVisible = !n.mobileFiltersVisible;
      return n;
    });
  }
</script>

<FizzStyles extraClasses={"fizz-full-width-search"}>
  <button
    on:click={swapFilters}
    class="fizz-button fizz-full-width"
    id="side-filter-mobile-button"
    data-testid="side-filter-mobile-button"
  >
    <div class="fizz-flex-row-8 fizz-justify-center">
      <div><Icon type="Filter2" /></div>
      <span class="fizz-text-regular">Filter{filtersCount > 0 ? ` (${filtersCount})` : ""}</span>
    </div>
  </button>
</FizzStyles>
